import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faMeh, faGauge, faChartBar } from '@fortawesome/free-solid-svg-icons';
import '../styles/ClassificationPage.css'; 

function ClassificationPage() {
  const [postagem, setPostagem] = useState('');
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensagemNotificacao, setMensagemNotificacao] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentPosts = resultados.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(resultados.length / recordsPerPage);

  useEffect(() => {
    const fetchClassificacoes = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data/classificacoes_postagens`);
        const data = await response.json();
        const resultadosOrdenados = Array.isArray(data)
          ? data.sort((a, b) => new Date(b.data) - new Date(a.data))
          : [];
        setResultados(resultadosOrdenados);
      } catch (error) {
        console.error("Erro ao carregar classificações:", error);
        setResultados([]);
      }
    };

    fetchClassificacoes();
  }, []);

  const handleClassificar = async () => {
    if (!postagem) {
      alert("Por favor, insira uma postagem para classificar.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL.replace(/\/api$/, '')}/api/data/classify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text: postagem }),
      });

      const data = await response.json();

      if (data.error) {
        alert("Erro ao classificar a postagem.");
        setLoading(false);
        return;
      }

      let classificacao = 'Ausente';
      if (data.classification.label === 1) {
        classificacao = 'Moderada';
      } else if (data.classification.label === 2) {
        classificacao = 'Grave';
      }

      const novoResultado = {
        texto: postagem,
        classificacao,
        data: new Date().toISOString()
      };

      await fetch(`${process.env.REACT_APP_API_BASE_URL}/data/classificacoes_postagens`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(novoResultado),
      });

      setResultados(prevResultados => [novoResultado, ...prevResultados]);
      setMensagemNotificacao('Postagem classificada com sucesso!');
      setPostagem('');

      setTimeout(() => {
        setMensagemNotificacao('');
      }, 3000);

    } catch (error) {
      console.error("Erro ao classificar a postagem:", error);
      alert("Erro ao classificar a postagem. Verifique a conexão com o servidor.");
    } finally {
      setLoading(false);
    }
  };

  const handleLimpar = () => {
    setPostagem('');
  };

  return (
    <div className="classificacao-container">
      <h1 className="page-title">Classificador de Postagens</h1>
      <p className="page-subtitle">Classifique automaticamente suas postagens com base no conteúdo.</p>

      <textarea
        className="classificacao-textarea"
        placeholder="Digite a postagem aqui..."
        value={postagem}
        onChange={(e) => setPostagem(e.target.value)}
      ></textarea>
      
      <div className="classificacao-botoes-container">
        <button className="classificacao-botao" onClick={handleClassificar} disabled={loading}>
          {loading ? 'Classificando...' : 'Classificar'}
        </button>
        <button className="limpar-botao" onClick={handleLimpar} disabled={loading}>
          Limpar
        </button>
      </div>

      {loading && (
        <div className="loading-indicator">
          <p>Classificando, por favor aguarde...</p>
          <div className="spinner"></div>
        </div>
      )}

      {mensagemNotificacao && (
        <div className={`notificacao success`}>
          {mensagemNotificacao}
        </div>
      )}

      <div className="cards-wrapper">
        <div className="cards-container">
          <div className="card">
            <FontAwesomeIcon icon={faChartBar} className="card-icon icon-blue" />
            <h3>Total de Classificações</h3>
            <p>{resultados.length}</p>
          </div>
          <div className="card">
            <FontAwesomeIcon icon={faExclamationTriangle} className="card-icon icon-red" />
            <h3>Classificações Graves</h3>
            <p>{resultados.filter(res => res.classificacao === 'Grave').length}</p>
          </div>
          <div className="card">
            <FontAwesomeIcon icon={faGauge} className="card-icon icon-orange" />
            <h3>Classificações Moderadas</h3>
            <p>{resultados.filter(res => res.classificacao === 'Moderada').length}</p>
          </div>
          <div className="card">
            <FontAwesomeIcon icon={faMeh} className="card-icon icon-green" />
            <h3>Classificações Ausentes</h3>
            <p>{resultados.filter(res => res.classificacao === 'Ausente').length}</p>
          </div>
        </div>
      </div>

      {currentPosts.length > 0 && (
        <div>
          <h2>Classificações</h2>
          <div className="postagens-container-classifer">
            {currentPosts.map((resultado, index) => (
              <div key={index} className={`postagem-item ${resultado.classificacao ? resultado.classificacao.toLowerCase() : ''}`}>
                <h3>Texto da Postagem:</h3>
                <p style={{ textAlign: 'justify' }}>{resultado.texto}</p>

                <h3>Classificação:</h3>
                <p style={{ textAlign: 'left' }}>{resultado.classificacao || 'Sem classificação'}</p>

                <h3>Data:</h3>
                <p style={{ textAlign: 'left' }}>
                  {resultado.data ? new Date(resultado.data).toLocaleString() : 'Data inválida'}
                </p>
              </div>
            ))}
          </div>

          <div className="button-container">
            <button 
              className="pagination-button" 
              onClick={() => setCurrentPage(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              Anterior
            </button>
            <button 
              className="pagination-button" 
              onClick={() => setCurrentPage(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              Próxima
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClassificationPage;
